module.exports = __webpack_public_path__ + "media/brands/swift-6df817c7.png";